import { render, staticRenderFns } from "./starrating.vue?vue&type=template&id=f7a9b9ac&"
import script from "./starrating.vue?vue&type=script&lang=js&"
export * from "./starrating.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../var/task/node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

/* hot reload */
if (module.hot) {
  var api = require("/var/task/node_modules/vue-hot-reload-api/dist/index.js")
  api.install(require('vue'))
  if (api.compatible) {
    module.hot.accept()
    if (!api.isRecorded('f7a9b9ac')) {
      api.createRecord('f7a9b9ac', component.options)
    } else {
      api.reload('f7a9b9ac', component.options)
    }
    module.hot.accept("./starrating.vue?vue&type=template&id=f7a9b9ac&", function () {
      api.rerender('f7a9b9ac', {
        render: render,
        staticRenderFns: staticRenderFns
      })
    })
  }
}
component.options.__file = "tmp/tmp-2YBRTxCw5rpGm/JS/comp/starrating.vue"
export default component.exports